<template>
	<div class="columns is-mobile is-vcentered">
		<div class="column is-7">
			<div class="columns is-mobile is-vcentered">
				<div class="column is-narrow">
					<h1
						style="display: inline-block"
						class="is-hidden-mobile is-size-4 ml-3">
						Store Products
					</h1>
				</div>
				<div class="column">
					<span
						style="display: inline-block"
						class="p-2 is-size-6"
						>{{ product_count }}</span
					>
				</div>
			</div>
		</div>
		<div class="column">
			<div class="columns is-vcentered">
				<div class="column is-narrow">
					<label
						class="is-size-6"
						style="display: inline-block"
						>Search Store:</label
					>
				</div>
				<div class="column">
					<input
						class="input is-small"
						v-on:input="update_term"
						type="text"
						name="filter"
						placeholder="Just type to search" />
				</div>
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped></style>
<script type="text/javascript">
	export default {
		data: function () {
			return {
				has_loaded: this.$store.getters.has_loaded,
			};
		},
		mounted() {
			let _this = this;
			setInterval(function () {
				_this.filtered_products = _this.$store.getters.filtered_products;
				_this.loaded = _this.$store.getters.has_loaded;
				_this.has_loaded = _this.$store.getters.has_loaded;
			}, 100);
		},
		computed: {
			product_count: function () {
				if (!this.has_loaded) {
					return "Loading items...";
				}
				if (this.$store.state.productCount < 1) {
					return "No Items";
				} else {
					return this.$store.getters.productCount + " items";
				}
			},
		},
		methods: {
			update_term: function (e) {
				this.$store.dispatch("set_term", e.target.value);
			},
		},
	};
</script>
